<template>
  <div ref="loader" class="lds-dual-ring" />
</template>

<script>
export default {
  name: 'Loader',
  props: {
    color: {
      type: String,
      required: false,
      default: 'white'
    },
    size: {
      type: Number,
      required: false,
      default: 64
    }
  },
  data () {
    return {
      defaultSize: 64
    }
  },
  mounted () {
    this.$refs.loader.style.setProperty('--loader-color', this.color)
    this.$refs.loader.style.setProperty('--loader-size', `${this.size}px`)
  }
}
</script>